module.exports = __webpack_public_path__ + "media/images/img/banner/sidebnr_award03-47aca266eeb1b7feb34f38df617b2b59.png";